import { Position } from "../flyout/types";

const LONG_DASH = "\u2014";

export const RANGE_DELIMETER = ` ${LONG_DASH} ` as const;
export const EMPTY_DATE = "";
export const DATE_LENGTH = 8;

export const RU_FORMAT_PATTERN =
  /^(?<day>[0-9]{2}).(?<month>[0-9]{2}).(?<year>[0-9]{4})$/;
export const ISO_FORMAT_PATTERN =
  /^(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})$/;

export const SINGLE_DATE_INPUT_MASK = [
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const RANGE_DATE_INPUT_MASK = [
  ...SINGLE_DATE_INPUT_MASK,
  " ",
  `${RANGE_DELIMETER.trim()}`,
  " ",
  ...SINGLE_DATE_INPUT_MASK,
];

export const SINGLE_DATE_INPUT_PLACEHOLDER = "__.__.____";

export const RANGE_DATE_INPUT_PLACEHOLDER = `${SINGLE_DATE_INPUT_PLACEHOLDER}${RANGE_DELIMETER}${SINGLE_DATE_INPUT_PLACEHOLDER}`;

export const TABLET_AND_WIDER_POSITIONS: Position[] = [
  "bottom-start",
  "bottom-end",
  "top-start",
  "top-end",
];

export const MOBILE_POSITIONS: Position[] = ["bottom", "top"];
